import { render, staticRenderFns } from "./BookSummary.vue?vue&type=template&id=bbae5150&scoped=true"
import script from "./BookSummary.vue?vue&type=script&lang=js"
export * from "./BookSummary.vue?vue&type=script&lang=js"
import style0 from "./BookSummary.vue?vue&type=style&index=0&id=bbae5150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbae5150",
  null
  
)

export default component.exports